import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { reverseArrowIconDirectionForRtl } from '@application/Interfaces/Icons/utils'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

import { SVG } from './ArrowBigIcon.styled'

export const ArrowBigIcon: IconComponent = ({
    className,
    colorCode = 'g600',
    width = 22,
    height = 20,
    direction = 'right',
    onClick,
}) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    const directionTransformed = reverseArrowIconDirectionForRtl({
        iconDirection: direction,
        themeDirection: theme.direction,
    })

    return (
        <SVG
            className={className}
            width={width}
            height={height}
            direction={directionTransformed}
            onClick={onClick}
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1.625 10H20.375" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M11.625 1.25L20.375 10L11.625 18.75"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SVG>
    )
}
